module.exports = __webpack_public_path__ + "img/outline_bg_2025_04_25.92f7344d.png";